import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMobilePhone = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "mobile-phone" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 5.251,
			y: .75,
			width: 13.5,
			height: 22.5,
			rx: 3,
			ry: 3
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.251,
			y1: 18.75,
			x2: 18.751,
			y2: 18.75
		})
	]
});
export default SvgMobilePhone;
